"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.mutatorAction('selectSkypeNotificationOption', function selectSkypeNotificationOption(notificationType, isImNotification) {
    var optionState = store_1.default();
    if (isImNotification) {
        optionState.imNotification = notificationType;
    }
    else {
        optionState.callNotification = notificationType;
    }
});
//# sourceMappingURL=selectSkypeNotificationOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-skype-option/lib/data/mutators/selectSkypeNotificationOption.js
// module id = 3377
// module chunks = 2 39